<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <h1>{{ meta.title }}</h1>
          <v-spacer></v-spacer>
          <v-btn
            small
            v-if="canBooking('BOOK_TRIAL')"
            color="warning"
            :to="{ name: allRoutes.booking.children.bookAtrial.name }"
          >
            Забронировать
          </v-btn>
          <v-btn
            small
            v-if="canTrial('NEW_TRIAL')"
            color="success"
            :to="{ name: allRoutes.trial.children.trialNew.name }"
          >
            Новый трайл
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <data-table
            :model="model"
            :headers="headers"
            :selected.sync="selected"
            @edit="editItem"
            @delete="deleteItem"
            @detail="showItem"
            @deleteSelected="deleteSelectedItem"
          />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Trial from '@/orm/models/Trial';
import ProcessStages from '@/orm/models/ProcessStages';
import ProcessSteps from '@/orm/models/ProcessSteps';
import { CONST } from '@/utils';
import asyncComponent from '@/utils/asyncComponent';

export default {
  name: 'trialAll',
  async asyncData() {
    await ProcessStages.$fetch();
    await ProcessSteps.$fetch();
  },
  data() {
    return {
      model: Trial,
      search: '',
      headers: CONST.trial.headers,
      selected: [],
    };
  },
  computed: {
    meta() {
      return this.$route.meta;
    },
  },
  methods: {
    editItem(id) {
      this.$router.push({
        name: this.allRoutes.trial.children.trialDetail.name,
        params: { id, editMode: true },
      });
    },
    async deleteItem(id) {
      await Trial.delete(+id);
      await Trial.$delete({
        params: { id },
      });
    },
    async deleteSelectedItem() {
      for (let { id } of this.selected) {
        await this.deleteItem(id);
      }
    },
    showItem(id) {
      this.$router.push({
        name: this.allRoutes.trial.children.trialDetail.name,
        params: { id },
      });
    },
  },
  components: {
    dataTable: asyncComponent({
      component: 'components/data/dataTable',
    }),
  },
};
</script>
